import { render, staticRenderFns } from "./MessageInput.vue?vue&type=template&id=080688e8&scoped=true"
import script from "./MessageInput.vue?vue&type=script&lang=js"
export * from "./MessageInput.vue?vue&type=script&lang=js"
import style0 from "./MessageInput.vue?vue&type=style&index=0&id=080688e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080688e8",
  null
  
)

export default component.exports